import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            浏览内容分类
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            按照不同主题浏览jm下载相关内容，快速找到您需要的信息
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 text-center transition-all duration-200 hover:border-primary-200/60 cursor-pointer"
            >
              <span className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-primary-100 rounded-lg group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-600`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}